import React, { useCallback, useEffect, useState } from 'react'
import { useLazyGetUserEmotionsQuery } from '../../../api/v2/emotions'
import { useMyContext } from '../../../context/context'
import useSettingsV2 from '../../../hooks/useSettingsV2'
import useWebsocketV2 from '../../../hooks/useWebsocketV2'
import FullScreen from '../../../shared/FullScreen'

function ReactionBubble({ src, showVisible }) {
  const [visible, setVisible] = useState(showVisible || false)
  const [left, setLeft] = useState(Math.floor(Math.random() * 100))

  // useEffect(() => {
  //   const timer = setTimeout(() => setVisible(false), 2000)
  //   return () => clearTimeout(timer)
  // }, [])

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), Math.floor(Math.random() * 12000))
    return () => clearTimeout(timer)
  }, [])

  if (!visible) return null

  return (
    <img src={src} style={{ left: left < 50 ? `calc(${left}% + 30px)` : `calc(${left}% - 90px)` }} className="reaction" alt="reaction" />
  )
}

export default function Emotions() {
  const [reactions, setReactions] = useState([])

  const { myContext } = useMyContext()
  const { settings } = useSettingsV2()

  const [getEmotions] = useLazyGetUserEmotionsQuery()

  const onMessage = useCallback(result => {
    const { type, data } = result
    if (type === 'NEW_EMOTION') {
      setReactions(prev => [...prev, { id: prev.length, src: data.iconUrl, showVisible: true }])
    }
  }, [])

  const { sequenceId } = useWebsocketV2({ onMessage })

  useEffect(() => {
    if (sequenceId) {
      getEmotions({ ...myContext, sequenceId })
        .unwrap()
        .then(emotions => setReactions(emotions.map((m, i) => ({ id: i, src: m.iconUrl }))))
    }
  }, [getEmotions, myContext, sequenceId])

  return (
    <FullScreen
      style={{
        backgroundImage: `url(${settings?.FO_MEETING_EMOTIONS_BACKGROUND})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}
    >
      {reactions.map(r => (
        <ReactionBubble key={r.id} src={r.src} showVisible={r.showVisible} />
      ))}
    </FullScreen>
  )
}
